
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const SkeletonPhoto: React.FC = () => {
  return (
    <div className="bg-white rounded-lg border shadow-sm overflow-hidden animate-pulse">
      <Skeleton className="aspect-[3/4] w-full" />
      <div className="p-3 space-y-2">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-full" />
        <div className="flex gap-1">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-12" />
        </div>
      </div>
    </div>
  );
};
